export default {
  setCurrentPersonInfo(context, value) {
    context.commit('setCurrentPersonInfo', value)
  },
  setCurrentAppAuthsInOrg(context, value) {
    context.commit('setCurrentAppAuthsInOrg', value)
  },
  setCurrentOrg(context, value) {
    context.commit('setCurrentOrg', value)
  },
  updateNavPage(context, value) {
    context.commit('updateNavPage', value)
  },
  setSelectOrgTree(context, value) {
    context.commit('setSelectOrgTree', value)
  },
  setAppsInOrg(context, value) {
    context.commit('setAppsInOrg', value)
  },
  setCurrentMicroApps(context, value) {
    context.commit('setCurrentMicroApps', value)
  },
  setPCCommonData(context, value) {
    context.commit('setPCCommonData', value)
  },
  setAppsInOrgs(context, value) {
    context.commit('setAppsInOrgs', value)
  },
  setToken(context, value) {
    context.commit('setToken', value)
  },
  setTabs(context, value) {
    context.commit('setTabs', value)
  },
  setIframes(context, value) {
    context.commit('setIframes', value)
  },
  setLoadedMicroApps(context, value) {
    context.commit('setLoadedMicroApps', value)
  },
  setExternalApp(context, value) {
    context.commit('setExternalApp', value)
  },
}
